import { useState, useEffect, useRef } from "react";
import { Input, CountDown } from "react-vant";
import { toast } from "@/components/common/Toast";
import { checkValidateCode, sendValidateCode } from "@/pages/api/auth";
import { useTranslation } from "next-i18next";
import { Progress } from "react-vant";
import AlreadyHaveAccount from "@/components/login/ui/AlreadyHaveAccount";
import TipBox from "@/components/login/ui/TipBox";
import type { CountDownInstance } from "react-vant";
import { sendSlsEvent } from "@/hooks/useAnalytics";
import { useElapsedTime } from "@/utils/useElapsedTime";
import { useRouter } from "next/router";
interface VerifyCodeFormProps {
  onClose: () => void;
  goLogin: () => void;
  goSetPassword: () => void;
  userInputEmail: string;
  verifyCodeType: string;
}

const VerifyCodeForm = ({
  goLogin,
  goSetPassword,
  userInputEmail,
  verifyCodeType,
}: VerifyCodeFormProps) => {
  console.log("redner count");
  const getElapsed = useElapsedTime();
  const pageId =
    verifyCodeType === "0" ? "mailsignup_verify_web" : "maillogin_verify_web";
  const router = useRouter();
  const code = router?.query?.code as string;
  const { t } = useTranslation();
  const [codeList, setCodeList] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  // 添加聚焦状态跟踪
  const [focusedIndex, setFocusedIndex] = useState<number | null>(null);
  const [showResend, setShowResend] = useState(false);
  const hasSentCode = useRef(false);
  const countDownRef = useRef<CountDownInstance>(null);
  const [remainingMs, setRemainingMs] = useState(60 * 1000);
  const handleLeft = () => {
    console.log("handleLeft---verify-code-form----");
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageLeave",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
      UM_Key_Duration: getElapsed(),
    });
  };
  useEffect(() => {
    return () => {
      handleLeft();
    };
  }, []);
  useEffect(() => {
    sendSlsEvent({
      UM_Key_EventName: "UM_Event_PageView",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_DistinctID: "",
      UM_Key_UserID: "",
    });
  }, []);

  const getExpireStorageKey = (email: string, type: string) =>
    `verifyCodeExpire:${email}:${type}`;

  const sendCode = (userInputEmail: string, verifyCodeType: string) => {
    sendValidateCode({
      email: userInputEmail,
      type: Number(verifyCodeType),
    }).then((res: any) => {
      console.log("发送验证码", res);

      if (res?.code === "00000") {
        toast.success(t("login.toast.code_sent"));
        const expireAt = Date.now() + 60 * 1000;
        try {
          localStorage.setItem(
            getExpireStorageKey(userInputEmail, verifyCodeType),
            String(expireAt)
          );
        } catch (e) {}
        setRemainingMs(60 * 1000);
        countDownRef.current?.reset();
        countDownRef.current?.start();
      } else if (res.code === "-40004") {
        toast.error(t("login.toast.codeSentCountTip"));
        setShowResend(true);
      } else {
        toast.error(t("login.toast.code_error"));
      }
    });
  };
  useEffect(() => {
    // 首次进入时，若本地存在未过期的倒计时，则继续倒计时；否则发送验证码
    try {
      const saved = localStorage.getItem(
        getExpireStorageKey(userInputEmail, verifyCodeType)
      );
      const expireAt = saved ? Number(saved) : 0;
      const now = Date.now();
      if (expireAt && expireAt > now) {
        const left = expireAt - now;
        setRemainingMs(left);
        setShowResend(false);
        hasSentCode.current = true; // 阻止再次自动发送
        // 等待渲染完成后启动倒计时
        setTimeout(() => {
          countDownRef.current?.reset();
          countDownRef.current?.start();
        }, 0);
        return;
      }
    } catch (e) {}

    if (!hasSentCode.current) {
      hasSentCode.current = true;
      console.log("发送验证码---", userInputEmail);
      sendCode(userInputEmail, verifyCodeType);
    }
  }, []);

  useEffect(() => {
    // 自动聚焦第一个输入框
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
      setFocusedIndex(0); // 设置初始聚焦索引
    }
  }, []);

  useEffect(() => {
    if (codeList.join("").length === 6) {
      // todo 校验验证码
      checkValidateCode({
        email: userInputEmail,
        code: codeList.join(""),
        type: Number(verifyCodeType),
      })
        .then((res) => {
          if (res?.code === "00000") {
            // toast.success(t("login.toast.code_correct"));
            countDownRef.current?.reset();
            try {
              localStorage.removeItem(
                getExpireStorageKey(userInputEmail, verifyCodeType)
              );
            } catch (e) {}
            goSetPassword();
          } else {
            toast.error(t("login.toast.code_error"));
          }
        })
        .catch((err) => {
          toast.error(t("login.toast.send_failed"));
          setShowResend(true);
        });
    }
  }, [codeList, goSetPassword]);

  const handleResend = () => {
    setShowResend(false);
    setCodeList(["", "", "", "", "", ""]);
    countDownRef.current?.reset();

    sendSlsEvent({
      UM_Key_EventName: "UM_Event_ModularClick",
      UM_Key_ButtonName: "resendcode",
      UM_Key_PageName: pageId,
      UM_Key_UserType: "Guest",
      UM_Key_SourcePage: router.route,
      UM_Key_ResourceID: code,
    });

    try {
      const expireAt = Date.now() + 60 * 1000;
      localStorage.setItem(
        getExpireStorageKey(userInputEmail, verifyCodeType),
        String(expireAt)
      );
    } catch (e) {}
    setRemainingMs(60 * 1000);
    sendCode(userInputEmail, verifyCodeType);
  };

  return (
    <div className="flex flex-col items-center w-[calc(100%-40px)]">
      {verifyCodeType === "1" && (
        <div className="w-full mb-[22px] mt-[16px]">
          <Progress
            style={{ width: "100%", borderRadius: "100px" }}
            strokeWidth={5}
            trackColor={"#eee"}
            percentage="50"
            color="#1677FF"
            showPivot={false}
          ></Progress>
        </div>
      )}
      <div className="text-[14px] font-['Mulish'] font-[400] text-[#333] mb-[6px]">
        <span className="font-[700]">({userInputEmail})</span>{" "}
        {t("login.already_registered")}
      </div>

      <div className="text-[14px] font-['Mulish'] font-[400] text-[#333]">
        {t("login.supports_quick_login")}
      </div>

      <div className="flex flex-row justify-between gap-[6px] mb-[16px]">
        {codeList.map((item, index) => (
          <div key={index}>
            <Input
              value={item}
              onChange={(v) => {
                const newCodeList = [...codeList];
                newCodeList[index] = v;
                setCodeList(newCodeList);
                if (v.length === 1 && inputRefs.current[index + 1]) {
                  inputRefs.current[index + 1]?.focus();
                  setFocusedIndex(index + 1);
                }
              }}
              onFocus={() => setFocusedIndex(index)}
              onBlur={() => setFocusedIndex(null)}
              maxLength={1}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  if (codeList[index]) {
                    // 当前有内容，清空
                    const newCodeList = [...codeList];
                    newCodeList[index] = "";
                    setCodeList(newCodeList);
                  } else if (index > 0) {
                    // 当前为空，聚焦前一个并清空
                    inputRefs.current[index - 1]?.focus();
                    setFocusedIndex(index - 1);
                    const newCodeList = [...codeList];
                    newCodeList[index - 1] = "";
                    setCodeList(newCodeList);
                  }
                }
              }}
              className={`bg-[#f2f2f2] rounded-[6px] mt-[30px] h-[56px] ps-[20px] text-[24px] font-[700] text-[#000] ${
                focusedIndex === index ? "border-[2px] border-[#1677FF]" : ""
              }`}
              ref={(el) => {
                if (el) {
                  inputRefs.current[index] = el.nativeElement;
                } else {
                  inputRefs.current[index] = null;
                }
              }}
              autoFocus={index === 0}
            />
          </div>
        ))}
      </div>
      {!showResend ? (
        <CountDown
          ref={countDownRef}
          time={remainingMs}
          millisecond
          format="ss"
          onFinish={() => {
            setShowResend(true);
            countDownRef.current?.reset();
            try {
              localStorage.removeItem(
                getExpireStorageKey(userInputEmail, verifyCodeType)
              );
            } catch (e) {}
          }}
        >
          {(timeData) => (
            <span className="text-[14px] font-['Mulish'] font-[700] text-[#ccc] mb-[14px]">
              {t("login.resendIn", { seconds: timeData.seconds })}
            </span>
          )}
        </CountDown>
      ) : (
        <div
          onClick={handleResend}
          className="text-[14px] font-['Mulish'] font-[700] text-[#1677FF] mb-[14px]"
        >
          {t("login.resend")}
        </div>
      )}
      <TipBox label={t("login.checkEmailTip")} color="#333" fontSize={12} />
      {verifyCodeType == "0" ? (
        <AlreadyHaveAccount
          goLogin={goLogin}
          classNames="mt-[54px] mb-[11px]"
          pageId={pageId}
        />
      ) : null}
    </div>
  );
};

export default VerifyCodeForm;
